import * as yup from 'yup';
import StringArrayField from '@shared/fields/string-array-field';
import ManageEnum from '@shared/manage/manage-enum';
import _values from 'lodash/values';

export default class ManageTypeField extends StringArrayField {

  constructor(name, label, values, config) {
    super(name, label, config);
    this.values = values
    this.options = _values(values).map((value) => (ManageEnum.selectOption(value)))
  }

  forExport() {
    return yup
      .mixed()
      .label(this.label)
      .transform((values) =>
        values ?
          values
            .map((value) => this.values.labelOf(value))
            .join(' ') :
          null,
      );
  }
}
